// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"b72480e2","754":"dd72564f"}[chunkId] + ".chunk.js";
};